import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=7a096a53&scoped=true&"
import script from "./editor.vue?vue&type=script&lang=js&"
export * from "./editor.vue?vue&type=script&lang=js&"
import style0 from "./editor.vue?vue&type=style&index=0&id=7a096a53&prod&lang=scss&scoped=true&"
import style1 from "./editor.vue?vue&type=style&index=1&id=7a096a53&prod&lang=scss&"
import style2 from "./editor.vue?vue&type=style&index=2&id=7a096a53&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a096a53",
  null
  
)

export default component.exports